<template>
  <section>
    <div style="position: relative">
      <v-container>
        <v-speed-dial
          absolute
          v-model="speedDial"
          top
          right
          direction="bottom"
          :open-on-hover="true"
        >
          <template v-slot:activator>
            <v-tooltip right color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  v-model="speedDial"
                  color="primary"
                  dark
                  x-large
                  fab
                >
                  <v-icon v-if="speedDial">mdi-close</v-icon>
                  <v-icon v-else>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>Opções</span>
            </v-tooltip>
          </template>

          <v-tooltip right color="secondary">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                dark
                small
                color="secondary"
                large
                @click="openModalNewRetention"
                v-if="$store.getters.hasPermission(['super', 'guarantees.create'])"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Registar</span>
          </v-tooltip>
        </v-speed-dial>
      </v-container>

      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :footer-props="tableFooter"
        class="mt-16"
        locale="pt-pt"
      >
        <template v-slot:item.created_at="{ item }">
          {{ formatDate(item.created_at) }}
        </template>

        <template v-slot:item.retencoes_dinheiro_total="{ item }">
          {{ item.retencoes_dinheiro_total ?? '-' }}
        </template>

        <template v-slot:item.retencoes_dinheiro_total_reduzir="{ item }">
          {{ item.retencoes_dinheiro_total_reduzir ?? '-' }}
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex align-center">
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  class="mr-2"
                  @click="printRetencoes(item.id)"
                >
                  <v-icon small>mdi-printer</v-icon>
                </v-btn>
              </template>
              <span>Imprimir</span>
            </v-tooltip>

            <IconView class="mr-2" @click="viewRetention(item)" />
          </div>
        </template>
      </v-data-table>
    </div>

    <v-dialog width="1200px" v-model="createRetentionModal">
      <v-card>
        <v-card-title class="primary white--text">
          {{ retention.id ? 'Editar retenções' : 'Adicionar retenções' }}
        </v-card-title>

        <v-card-text class="mt-4">
          <validation-observer ref="form" v-slot="{ invalid }">
            <v-form @submit.prevent="submitRetention" class="mb-8">
              <v-row>
                <v-col cols="12">
                  <div class="retencoes-table-wrapper">
                    <table class="retencoes-table">
                      <thead>
                        <tr class="primary white--text">
                          <th class="warning white--text">Emissão</th>
                          <th class="warning white--text">N.º</th>
                          <th class="warning white--text">Instituição</th>
                          <th class="warning white--text">Valor de RP</th>
                          <th class="warning white--text">Valor</th>
                          <th class="warning white--text">Valor a reduzir</th>
                          <th class="warning white--text">Ações</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(line, index) in retention.linhas"
                          :key="line._uid"
                        >
                          <td>
                            <validation-provider
                              v-slot="{ errors }"
                              :vid="'emissao_' + index"
                              :name="'Emissão ' + (index + 1)"
                              rules="required"
                            >
                              <v-menu
                                v-model="line.menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                :disabled="!isLineEditable(line)"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="line.emissao"
                                    dense
                                    outlined
                                    label="Emissão"
                                    hide-details="auto"
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    :disabled="!isLineEditable(line)"
                                    :error-messages="errors"
                                    v-bind="attrs"
                                    v-on="isLineEditable(line) ? on : {}"
                                  />
                                </template>

                                <v-date-picker
                                  v-if="isLineEditable(line)"
                                  v-model="line.emissao"
                                  @input="line.menu = false"
                                />
                              </v-menu>
                            </validation-provider>
                          </td>

                          <td>
                            <validation-provider
                              v-slot="{ errors }"
                              :vid="'numero_' + index"
                              :name="'Número ' + (index + 1)"
                              rules="required"
                            >
                              <v-text-field
                                v-model="line.numero"
                                dense
                                outlined
                                label="N.º"
                                hide-details="auto"
                                :disabled="!isLineEditable(line)"
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </td>

                          <td>
                            <validation-provider
                              v-slot="{ errors }"
                              :vid="'instituicao_' + index"
                              :name="'Instituição ' + (index + 1)"
                              rules="required"
                            >
                              <v-text-field
                                v-model="line.instituicao"
                                dense
                                outlined
                                label="Instituição"
                                hide-details="auto"
                                :disabled="!isLineEditable(line)"
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </td>

                          <td>
                            <validation-provider
                              v-slot="{ errors }"
                              :vid="'valor_rp_' + index"
                              :name="'Valor de RP ' + (index + 1)"
                              :rules="index === 0 ? 'required' : ''"
                            >
                              <!--<v-text-field
                                v-model="line.valor_rp"
                                dense
                                outlined
                                label="Valor de RP"
                                hide-details="auto"
                                type="number"
                                :disabled="isValorRpDisabled(index)"
                                :error-messages="errors"
                                @input="onValorRpChange"
                              />-->
                              <InputNumber 
                                v-model="line.valor_rp" 
                                format="accounting" 
                                label="Valor de RP"
                                hide-details="auto"
                                :disabled="isValorRpDisabled(index)"
                                :error-messages="errors"
                                dense
                                @input="onValorRpChange"
                                outlined />
                            </validation-provider>
                          </td>

                          <td>
                            <validation-provider
                              v-slot="{ errors }"
                              :vid="'valor_' + index"
                              :name="'Valor ' + (index + 1)"
                              rules="required"
                            >
                              <InputNumber 
                                v-model="line.valor" 
                                format="accounting" 
                                label="Valor"
                                hide-details="auto"
                                :disabled="!isLineEditable(line)"
                                :error-messages="errors"
                                dense
                                outlined />
                            </validation-provider>
                          </td>

                          <td>
                            <validation-provider
                              v-slot="{ errors }"
                              :vid="'valor_reduzir_' + index"
                              :name="'Valor a reduzir ' + (index + 1)"
                              rules="required"
                            >
                              <InputNumber 
                                v-model="line.valor_reduzir" 
                                format="accounting" 
                                label="Valor a reduzir"
                                hide-details="auto"
                                :disabled="!isLineEditable(line)"
                                :error-messages="errors"
                                dense
                                outlined />
                            </validation-provider>
                          </td>

                          <td class="text-center">
                            <div class="actions-cell">
                              <v-btn
                                fab
                                x-small
                                color="error"
                                @click="removeLine(index)"
                                :disabled="retention.linhas.length === 1 || !isLineEditable(line)"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>

                              <v-tooltip
                                v-if="isLastLine(index)"
                                top
                                :disabled="canAddNewLine"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                    <v-btn
                                      fab
                                      x-small
                                      color="success"
                                      @click="addLine"
                                      :disabled="!canAddNewLine"
                                    >
                                      <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                  </span>
                                </template>
                                <span>
                                  Grave a primeira linha com o Valor de RP definido para poder adicionar mais linhas.
                                </span>
                              </v-tooltip>
                            </div>
                          </td>
                        </tr>

                        <tr
                          v-for="(retencaoDinheiro, moneyIndex) in retention.retencoes_dinheiro"
                          :key="retencaoDinheiro._uid"
                          class="retencoes-dinheiro-row"
                        >
                          <td
                            v-if="moneyIndex === 0"
                            :rowspan="retention.retencoes_dinheiro.length"
                            colspan="3"
                            class="font-weight-medium retencoes-dinheiro-label"
                          >
                            Retenções em dinheiro
                          </td>

                          <td>                            
                            <InputNumber 
                              :value="firstValorRp"
                              dense
                              outlined
                              format="accounting" 
                              label="Valor de RP"
                              hide-details="auto"
                              type="number"
                              disabled />
                          </td>

                          <td>
                            <validation-provider
                              v-slot="{ errors }"
                              :vid="'retencoes_dinheiro_valor_' + moneyIndex"
                              :name="'Retenções em dinheiro - valor ' + (moneyIndex + 1)"
                              rules=""
                            >          
                              <InputNumber 
                                v-model="retencaoDinheiro.valor"
                                dense
                                outlined
                                label="Valor"
                                format="accounting" 
                                hide-details="auto"
                                type="number"
                                :disabled="!isMoneyEditable(retencaoDinheiro)"
                                :error-messages="errors" />
                            </validation-provider>
                          </td>

                          <td>
                            <validation-provider
                              v-slot="{ errors }"
                              :vid="'retencoes_dinheiro_valor_reduzir_' + moneyIndex"
                              :name="'Retenções em dinheiro - valor a reduzir ' + (moneyIndex + 1)"
                              rules=""
                            >
                              <InputNumber 
                                v-model="retencaoDinheiro.valor_reduzir"
                                dense
                                outlined
                                label="Valor a reduzir"
                                format="accounting" 
                                hide-details="auto"
                                type="number"
                                :disabled="!isMoneyEditable(retencaoDinheiro)"
                                :error-messages="errors" />
                            </validation-provider>
                          </td>

                          <td class="text-center">
                            <div class="actions-cell">
                              <v-btn
                                fab
                                x-small
                                color="error"
                                @click="removeRetencaoDinheiro(moneyIndex)"
                                :disabled="
                                  retention.retencoes_dinheiro.length === 1 ||
                                  !isMoneyEditable(retencaoDinheiro)
                                "
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>

                              <v-btn
                                v-if="isLastRetencaoDinheiro(moneyIndex)"
                                fab
                                x-small
                                color="success"
                                @click="addRetencaoDinheiro"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-col>

                <v-col cols="12" align="center">
                  <v-btn
                    :disabled="invalid || retention.linhas.length === 0"
                    rounded
                    type="submit"
                    class="primary"
                  >
                    Gravar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </validation-observer>
        </v-card-text>
      </v-card>
    </v-dialog>

    <DialogSuccess :opened="success" @on-ok="onSuccess">
      Retenções gravadas com sucesso!
    </DialogSuccess>
  </section>
</template>

<script>
import GarantiasRetencoes from "@/api/GarantiasRetencoes.js";
import DialogSuccess from "@/components/UI/DialogSuccess.vue";
import IconView from "@/components/UI/IconView.vue";

export default {
  components: {
    DialogSuccess,
    IconView,
  },

  data: () => ({
    loading: false,
    speedDial: false,
    success: false,
    createRetentionModal: false,
    items: [],
    retention: {
      id: null,
      garantias_obras_id: null,
      linhas: [],
      retencoes_dinheiro: [],
    },
    tableFooter: {
      "items-per-page-options": [5, 10, 15, 20],
      "items-per-page-text": "Linhas por página",
    },
    headers: [
      {
        text: "Criada a",
        sortable: false,
        value: "created_at",
      },
      {
        text: "Ret. dinheiro valor",
        sortable: false,
        value: "retencoes_dinheiro_total",
      },
      {
        text: "Ret. dinheiro valor a reduzir",
        sortable: false,
        value: "retencoes_dinheiro_total_reduzir",
      },
      {
        text: "Opções",
        sortable: false,
        value: "actions",
      },
    ],
  }),

  computed: {
    firstValorRp() {
      return this.retention?.linhas?.[0]?.valor_rp ?? null;
    },

    canAddNewLine() {
      return !!this.retention.id && !!this.firstValorRp;
    },
  },

  mounted() {
    this.searchRetentions();
  },

  methods: {
    isLineEditable(line) {
      return !this.retention.id || line.isNew;
    },

    isMoneyEditable(line) {
      return !this.retention.id || line.isNew;
    },
    printRetencoes(id){
      GarantiasRetencoes.printRetencoes(id)
        .then((response) => {
          window.open(response.data, "_blank");
        })
        .catch(() => {
          this.$toast.error("Erro ao gerar o PDF.");
        });
    },
    uniqueId(prefix = "row") {
      return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    },

    defaultLine() {
      return {
        _uid: this.uniqueId("line"),
        id: null,
        emissao: null,
        numero: null,
        instituicao: null,
        valor_rp: null,
        valor: null,
        valor_reduzir: null,
        menu: false,
        isNew: true,
      };
    },

    defaultRetencaoDinheiro() {
      return {
        _uid: this.uniqueId("money"),
        id: null,
        valor: null,
        valor_reduzir: null,
        isNew: true,
      };
    },

    openModalNewRetention() {
      this.retention = {
        id: null,
        garantias_obras_id: this.$route.params.id,
        linhas: [this.defaultLine()],
        retencoes_dinheiro: [this.defaultRetencaoDinheiro()],
      };

      this.createRetentionModal = true;
    },

    formatDate(date) {
      if (!date) return "-";
      return String(date).slice(0, 10);
    },

    normalizeValorRp() {
      const firstValorRp = this.retention?.linhas?.[0]?.valor_rp ?? null;

      this.retention.linhas = (this.retention.linhas || []).map((linha) => ({
        ...linha,
        valor_rp: firstValorRp,
      }));
    },

    onValorRpChange() {
      this.normalizeValorRp();
    },

    isValorRpDisabled(index) {
      if (index > 0) return true;
      return !!this.retention.id;
    },

    isLastLine(index) {
      return index === this.retention.linhas.length - 1;
    },

    isLastRetencaoDinheiro(index) {
      return index === this.retention.retencoes_dinheiro.length - 1;
    },

    addLine() {
      if (!this.canAddNewLine) return;

      this.retention.linhas.push({
        ...this.defaultLine(),
        valor_rp: this.firstValorRp,
      });
    },

    removeLine(index) {
      if (this.retention.linhas.length === 1) return;
      this.retention.linhas.splice(index, 1);
      this.normalizeValorRp();
    },

    addRetencaoDinheiro() {
      this.retention.retencoes_dinheiro.push(this.defaultRetencaoDinheiro());
    },

    removeRetencaoDinheiro(index) {
      if (this.retention.retencoes_dinheiro.length === 1) return;
      this.retention.retencoes_dinheiro.splice(index, 1);
    },

    viewRetention(item) {
  const firstValorRp = item?.linhas?.[0]?.valor_rp ?? null;

  this.retention = {
    id: item.id ?? null,
    garantias_obras_id: item.garantias_obras_id ?? this.$route.params.id,
    linhas: (item.linhas ?? []).map((linha) => ({
      _uid: this.uniqueId("line"),
      id: linha.id ?? null,
      emissao: linha.emissao ?? null,
      numero: linha.numero ?? null,
      instituicao: linha.instituicao ?? null,
      valor_rp: firstValorRp,
      valor: linha.valor ?? null,
      valor_reduzir: linha.valor_reduzir ?? null,
      menu: false,
      isNew: false,
    })),
    retencoes_dinheiro: (
      item.retencoes_dinheiro ??
      (item.retencoes_dinheiro_valor != null || item.retencoes_dinheiro_valor_reduzir != null
        ? [
            {
              id: null,
              valor: item.retencoes_dinheiro_valor ?? null,
              valor_reduzir: item.retencoes_dinheiro_valor_reduzir ?? null,
            },
          ]
        : [])
    ).map((money) => ({
      _uid: this.uniqueId("money"),
      id: money.id ?? null,
      valor: money.valor ?? null,
      valor_reduzir: money.valor_reduzir ?? null,
      isNew: false,
    })),
  };

  if (!this.retention.linhas.length) {
    this.retention.linhas = [this.defaultLine()];
  }

  if (!this.retention.retencoes_dinheiro.length) {
    this.retention.retencoes_dinheiro = [this.defaultRetencaoDinheiro()];
  }

      this.normalizeValorRp();
      this.createRetentionModal = true;
    },
    onSuccess() {
      this.success = false;
      this.createRetentionModal = false;
      this.searchRetentions();
    },

    submitRetention() {
      this.$refs.form?.validate?.().then?.((result) => {
        if (result === false) {
          return;
        }

        this.persistRetention();
      }) || this.persistRetention();
    },

    persistRetention() {
      this.loading = true;
      this.normalizeValorRp();

      const firstValorRp = this.firstValorRp;

      const data = {
        id: this.retention.id,
        garantias_obras_id: this.$route.params.id,
        linhas: this.retention.linhas.map((linha) => ({
          id: linha.id,
          emissao: linha.emissao,
          numero: linha.numero,
          instituicao: linha.instituicao,
          valor_rp: firstValorRp,
          valor: linha.valor,
          valor_reduzir: linha.valor_reduzir,
        })),
        retencoes_dinheiro: this.retention.retencoes_dinheiro.map((money) => ({
          id: money.id,
          valor_rp: firstValorRp,
          valor: money.valor,
          valor_reduzir: money.valor_reduzir,
        })),
      };

      const method = this.retention.id ? "update" : "create";

      GarantiasRetencoes[method](data, this.retention.id)
        .then(() => {
          this.success = true;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;

          if (err.response && err.response.status === 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
        });
    },

    searchRetentions() {
      this.loading = true;

      GarantiasRetencoes.search({
        garantias_obras_id: this.$route.params.id,
      })
        .then((response) => {
          const data = response.data;

          if (data && data.data && data.data.length > 0) {
            this.items = (data.data ?? []).map((item) => {
              const linhas = item.linhas ?? [];
              const firstValorRp = linhas?.[0]?.valor_rp ?? null;
              const retencoesDinheiro =
                item.retencoes_dinheiro ??
                (item.retencoes_dinheiro_valor != null || item.retencoes_dinheiro_valor_reduzir != null
                  ? [
                      {
                        valor: item.retencoes_dinheiro_valor ?? null,
                        valor_reduzir: item.retencoes_dinheiro_valor_reduzir ?? null,
                      },
                    ]
                  : []);

              return {
                ...item,
                linhas: linhas.map((linha) => ({
                  ...linha,
                  _uid: this.uniqueId("line"),
                  valor_rp: firstValorRp,
                  menu: false,
                })),
                retencoes_dinheiro: retencoesDinheiro.map((money) => ({
                  ...money,
                  _uid: this.uniqueId("money"),
                })),
                retencoes_dinheiro_total: retencoesDinheiro.reduce(
                  (sum, row) => sum + (parseFloat(row.valor) || 0),
                  0
                ),
                retencoes_dinheiro_total_reduzir: retencoesDinheiro.reduce(
                  (sum, row) => sum + (parseFloat(row.valor_reduzir) || 0),
                  0
                ),
              };
            });
          } else {
            this.items = [];
          }

          this.loading = false;
        })
        .catch(() => {
          this.items = [];
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.retencoes-table-wrapper {
  overflow-x: auto;
}

.retencoes-table {
  width: 100%;
  border-collapse: collapse;
}

.retencoes-table th,
.retencoes-table td {
  border: 1px solid #dcdcdc;
  padding: 12px;
  vertical-align: middle;
  background: white;
}

.retencoes-table th {
  text-align: left;
  font-weight: 600;
  white-space: nowrap;
}

.retencoes-dinheiro-row td {
  background: #fafafa;
}

.retencoes-dinheiro-label {
  min-width: 220px;
}

.actions-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
</style>
